export default "__VITE_ASSET__C0_dJsFe__"